// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7bb746e4","239":"4fceb046","453":"74c0ef60","455":"7e05c2a9"}[chunkId] + ".chunk.js";
};